import { useQuery, useMutation } from "@tanstack/react-query";
import apiClient from "./apiClient";
import Cookies from "js-cookie";

// Get the saved language (default to "en" if not set)
const SAVED_LANG = localStorage.getItem("lang") || "ar";

// Sign-up Mutation
export const useSignUp = () => {
  return useMutation({
    mutationFn: async (formData) => {
      const { data } = await apiClient.post("/auth/register", { ...formData,
        //  state: "Test"
       });
      return data;
    },
  });
};

// Login Mutation
export const useLogin = () => {
  return useMutation({
    mutationFn: async ({ email, password }) => {
      const { data } = await apiClient.post("/auth/login", {
        email,
        password,
      });
      return data;
    },
  });
};

// Login with Phone Mutation
export const useLoginWithPhone = () => {
  return useMutation({
    mutationFn: async (phone) => {
      console.log(phone);
      const { data } = await apiClient.post("/auth/login-phone", {
        phone,
      });
      return data;
    },
  });
};
// Signup with Phone Mutation
export const useSignUpWithPhone = () => {
  return useMutation({
    mutationFn: async (phone, name, email) => {
      const { data } = await apiClient.post("/auth/register-phone", {
        phone, name, email, 
        // state: "Test"
      });
      console.log(data);
      return data;
    },
  });
};

// Verify Phone Mutation (OTP)
export const useVerifyPhone = () => {
  return useMutation({
    mutationFn: async ({ phone, otp }) => {
      const { data } = await apiClient.post("/auth/verify-otp-login", {
        phone,
        otp,
      });
      return data;
    },
  });
};

// Verify Phone Mutation (OTP) Register
export const useVerifyPhoneRegister = () => {
  return useMutation({
    mutationFn: async ({ phone, otp }) => {
      const { data } = await apiClient.post("/auth/verify-otp-register", {
        phone,
        otp,
      });
      return data;
    },
  });
};

// Update User Info
export const useUpdateUser = () => {
  return useMutation({
    mutationFn: async (userData) => {
      const { data } = await apiClient.patch("/user/updateMyInfo", userData);
      return data;
    },
  });
};

// Create an Order
export const useCreateOrder = () => {
  return useMutation({
    mutationFn: async (orderData) => {
      const { data } = await apiClient.post("/orders/create", orderData);
      return data;
    },
  });
};

// Get All Orders
export const useGetOrders = () => {
  return useQuery({
    queryKey: ["orders"],
    queryFn: async () => {
      const { data } = await apiClient.get("/orders/my-orders");
      return data.data.orders;
    },
  });
};

// verify Pay Order
export const useVerifyPayOrder = () => {
  return useMutation({
    mutationFn: async ({ orderId, paymentId }) => {
      const { data } = await apiClient.patch(`/orders/verify/${orderId}`, {
        paymentId,
      });
      return data;
    },
  });
};

// Get All Mosques
export const useGetMosques = () => {
  return useQuery({
    queryKey: ["mosques"],
    queryFn: async () => {
      const { data } = await apiClient.get("/mosques");
      // console.log(data.data.mosques);
      return data.data.mosques;
    },
  });
};

// Fetch categories function
const fetchCategories = async () => {
  const { data } = await apiClient.get(
    `/categories?state=${
      Cookies.get("userData")?.state === "Test" ? "Test" : "Available"
    }`,
    {
      headers: { "Accept-Language": SAVED_LANG },
    }
  );
  if (data.status !== "success" || !Array.isArray(data.data)) {
    throw new Error("Invalid response format");
  }
  console.log(data.data);
  return data.data;
};

// Hook to get categories
export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: fetchCategories,
  });
};
